import { combineReducers } from 'redux';
import content from './terms-of-use-content';
import hasError from './terms-of-use-error';
import attachments from './terms-of-use-attachments';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';

const termsOfUse = combineReducers({
  content,
  hasError,
  attachments,
  isLoading: loadingStatusAccordingToReducer('termsOfUseLoadingStatus'),
});

export default termsOfUse;



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/reducers/terms-of-use.js